export default __webpack_public_path__ + "static/media/Spectrum-Typography.34ff1299.png";